import { render, staticRenderFns } from "./hand2.vue?vue&type=template&id=9f15b2e4&"
import script from "./hand2.vue?vue&type=script&lang=js&"
export * from "./hand2.vue?vue&type=script&lang=js&"
import style0 from "./hand2.vue?vue&type=style&index=0&id=9f15b2e4&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports